<template>
  <div class="navbar-item">
    <div class="subject-select-container">
      <b-button
        class="filter-button"
        @click="changeSubject('MATHS')"
        :disabled="this.getCurrentSubject === 'MATHS'"
      >
        MATHS
      </b-button>
      &nbsp;
      <b-button
        class="filter-button"
        @click="changeSubject('ENGLISH')"
        :disabled="this.getCurrentSubject === 'ENGLISH'"
      >
        ENGLISH
      </b-button>
    </div>
  </div>
</template>

<script>
import { mapMutations, mapActions } from "vuex";
import localizationMixin from "@/modules/global/mixins/localizationMixin.js";

export default {
  name: "SubjectSelect",
  props: {
    label: String
  },
  mixins: [localizationMixin],
  data() {
    return {
      // currentSubject: "MATHS"
    };
  },
  computed: {
    getCurrentSubject(state) {
      return state.$store.state.globalStore.activeFilterParams.currentSubject;
    }
  },
  methods: {
    ...mapMutations({
      updateCurrentSubject: "globalStore/setCurrentSubject",
      updateLearnersSubject: "globalStore/setLearnersCurrentSubject",
      updateActiveUser: "globalStore/updateActiveUser"
    }),
    ...mapActions({
      fetchMyLearners: "globalStore/fetchMyLearners"
    }),
    changeSubject(subject) {
      this.updateCurrentSubject(subject);
      this.updateLearnersSubject();
      this.$parent.filterResults();
      //force component refresh
      this.$parent.currentThreadIndex = 1;
      this.$parent.updateActiveValues();
      this.$parent.currentThreadIndex = 0;
      this.$parent.updateActiveValues();
      //force user modal data refresh
      this.updateActiveUser(false);
    }
  }
};
</script>
